import { CheckIcon } from '@heroicons/react/24/solid'

const RespondSuccessModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-background rounded-lg shadow-xl p-6 w-full max-w-sm mx-4 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-green-100 mb-4">
          <CheckIcon className="h-10 w-10 text-green-600" />
        </div>
        <h2 className="text-xl font-bold mb-2">Respond Submitted Successfully</h2>
        <p className="text-gray-700 mb-6">
          Your product respond has been sent to customer in the selected category. You'll receive
          suggestions soon—stay tuned for the best offers! 🎉
        </p>
        <button
          onClick={onClose}
          className="w-full px-6 py-3 text-lg font-medium text-white capitalize bg-gradient-to-r from-secondary-700 to-secondary-500 rounded-lg hover:opacity-90 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-secondary-600 transition-opacity shadow"
        >
          View Response
        </button>
      </div>
    </div>
  )
}

export default RespondSuccessModal
